import React from 'react';
import {
  MenuItemProps,
  TypographyProps,
  useTheme,
  InputAdornment,
  SelectProps,
  TextFieldProps,
  Tooltip,
  FormHelperText,
} from '@mui/material';
import {
  StyledSelect,
  StyledMenuItem,
  StyledFormControl,
  StyledLabel,
  Input,
  StyledDatePicker,
  StyledTooltipIndicator,
} from './InputDropdown.styled';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { DateTimePicker as MuiDatePicker, DateTimePickerProps, DatePickerProps, DatePicker } from '@mui/lab';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/base/calendar.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/base/chevron-down.svg';
import Datepicker from 'react-datepicker';

interface InputLabelProps extends TypographyProps {
  tooltip?: string | React.ReactNode;
}

export const InputItem = (props: MenuItemProps) => {
  const { children, ...rest } = props;

  return (
    <StyledMenuItem {...rest}>
      {children}
    </StyledMenuItem>
  );
};

export const InputLabel = (props: InputLabelProps) => {
  const { children, tooltip, ...rest } = props;

  return (
    <StyledLabel {...rest}>
      {children}
      {tooltip && (
        <Tooltip
          title={tooltip}
          placement="top-end"
        >
          <StyledTooltipIndicator>i</StyledTooltipIndicator>
        </Tooltip>
      )}
    </StyledLabel>
  );
};

export const BasicInput = (props: TextFieldProps) => {
  return (
    <StyledFormControl aria-autocomplete={'none'} fullWidth sx={{ margin: '0px' }}>
      <Input
        autoComplete={'off'}
        data-lpignore={'true'}
        type={'search'}
        inputProps={{
          'data-lpignore': true,
          autoComplete: 'off',
          role: 'search',
          id: 'search-input',
        }}
        {...props}
      />
    </StyledFormControl>
  );
};


export const SelectWrapper = (props: SelectProps & { helperText?: string | null }) => {
  // const theme = useTheme();
  const { children, error, helperText, ...rest } = props;

  return (
    <StyledFormControl error={error} sx={{ margin: '0px', width: '100%' }}>
      <StyledSelect
        value={'Select'}
        MenuProps={{
          MenuListProps: {
            sx: {
              padding: '0px',
              maxHeight: '320px',
            },
          },
        }}
        IconComponent={ArrowDown}
        data-lpignore={'true'}
        autoComplete={'off'}
        {...rest}
      >
        {children}
      </StyledSelect>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </StyledFormControl>
  );
};


export const DateTimePicker = (props: DateTimePickerProps) => {
  const theme = useTheme();
  const { disableFuture = true, maxDateTime, ...rest } = props;
  const effectiveMaxDateTime = disableFuture && !maxDateTime ? new Date() : maxDateTime;
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiDatePicker
        // renderInput={(params) => <Input sx={{ margin: '0px', width: '100%' }} {...params} />}
        components={{
          OpenPickerIcon: CalendarIcon,
        }}
        reduceAnimations
        data-lpignore={'true'}
        maxDateTime={effectiveMaxDateTime}
        disableFuture={disableFuture}
        OpenPickerButtonProps={{
          sx: {
            color: 'grey.400',
            svg: {
              height: '20px',
              width: '20px',
              stroke: theme.palette.grey[400],
            },
            '&:hover': {
              color: 'grey.600',
              svg: {
                stroke: theme.palette.grey[600],
              },
            },
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};


export const DateTimePickerNew = (props: any) => {
  const { disableFuture = true, maxDate, ...rest } = props;
  const effectiveMaxDate = disableFuture && !maxDate ? new Date() : maxDate;
  return (
    <StyledDatePicker>
      <Datepicker
        showTimeInput
        placeholderText={'mm/dd/yyyy hh:mm'}
        data-lpignore={'true'}
        maxDate={effectiveMaxDate}
        maxTime={effectiveMaxDate}
        customInput={
          <Input
            type='search'
            inputProps={{
              'data-lpignore': true,
              autoComplete: 'off',
              role: 'search',
              id: 'search-time',
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <CalendarIcon />
                </InputAdornment>
              ),
            }} />
        }
        {...rest}
      />
    </StyledDatePicker>
  );
};

export const MDatePicker = (props: DatePickerProps) => {
  const theme = useTheme();
  const { disableFuture = true, maxDate, ...rest } = props;
  const effectiveMaxDate = disableFuture && !maxDate ? new Date() : maxDate;
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        // renderInput={(params) => <Input sx={{ margin: '0px', width: '100%' }} {...params} />}
        components={{
          OpenPickerIcon: CalendarIcon,
        }}
        reduceAnimations
        data-lpignore={'true'}
        maxDate={effectiveMaxDate}
        disableFuture={disableFuture}
        OpenPickerButtonProps={{
          sx: {
            color: 'grey.400',
            svg: {
              height: '20px',
              width: '20px',
              stroke: theme.palette.grey[400],
            },
            '&:hover': {
              color: 'grey.600',
              svg: {
                stroke: theme.palette.grey[600],
              },
            },
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};
